const { find } = require('lodash');

class DynamicContentRestrictedProductController {
    constructor(settings, dynamicContentService, shopperService, validateProductService, $filter, trolleyService, $rootScope, $document, $timeout) {
        this.settings = settings;
        this.dynamicContentService = dynamicContentService;
        this.shopperService = shopperService;
        this.validateProductService = validateProductService;
        this.$filter = $filter;
        this.trolleyService = trolleyService;
        this.$document = $document;
        this.$timeout = $timeout;

        this.eligibleForCarePackage = true;
        this.limitExceeded = false;
        this.enableCheckoutButton = false;

        this.removeNoScroll();

        if (!this.shopperService.IsGuest) {
            if (this.settings.carePackage.isEnabled) {
                this.validateProductService.validate([this.itemId]).then((res) => {
                    const product = find(res.Eligibility, { StockCode: this.itemId });
                    if (!product.Eligible) {
                        const day = this.formatDate(this.$filter('date')(product.NextEligibleDate, 'd'));
                        const month = this.$filter('date')(product.NextEligibleDate, 'MMMM');
                        this.limitExceededTitle = this.settings.carePackage.limitExceededTitle
                            .replace('{date}', `${day} ${month}`);
                        this.limitExceededMessage = this.settings.carePackage.limitExceededMessage
                            .replace(/{date}/gi, `${day} ${month}`);
                        this.limitExceeded = true;
                    }
                });
            } else {
                this.eligibleForCarePackage = false;
            }
        }

        this.getProduct();

        $rootScope.$on('trolley:update', () => {
            this.removeNoScroll();
            this.checkOutButtonStatus();
        });
    }

    formatDate(day) {
        const quotient = (day - day % 10) / 10;
        const remainder = day % 10;

        if (quotient === 1) {
            return `${day}th`;
        }
        switch (remainder) {
            case 1: return `${day}st`;
            case 2: return `${day}nd`;
            case 3: return `${day}rd`;
            default: return `${day}th`;
        }
    }

    getProduct() {
        this.dynamicContentService.getServerItems({ Products: [this.itemId] }).then((res) => {
            this.item = res.Products[0];
            this.checkOutButtonStatus();
        });
    }

    checkOutButtonStatus() {
        const trolleyItem = this.trolleyService.getTrolleyItem(this.itemId);
        if (trolleyItem !== undefined && trolleyItem !== null) {
            if (trolleyItem.Quantity > 0) {
                this.enableCheckoutButton = true;
            }
        }
        if (trolleyItem === undefined || trolleyItem === null || trolleyItem.Quantity === 0) {
            this.enableCheckoutButton = false;
        }
    }

    removeNoScroll() {
        this.$timeout(() => { this.$document.find('body').removeClass('noscroll'); }, 300);
    }
}

DynamicContentRestrictedProductController.$inject = ['Settings', 'DynamicContentService', 'ShopperService', 'ValidateProductService', '$filter', 'TrolleyService', '$rootScope', '$document', '$timeout'];

const dynamicContentRestrictedProductComponentDefinition = {
    bindings: {
        itemId: '<',
    },
    controller: DynamicContentRestrictedProductController,
    template: require('./dynamic-content-restricted-product.component.html').trim(),
};

module.exports = {
    DynamicContentRestrictedProductController,
    dynamicContentRestrictedProductComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/restrictedproduct/dynamic-content-restricted-product.component.js